import { useState } from "react";
import axios from "axios";
import { Loader2, CheckCircle2 } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NEWSLETTER_BRANDS = [
  "All Brands",
  "Gopi Gadhvi Group",
  "Monarch Estates",
  "Monarch Design Studio",
  "The Art Forest",
  "The Wishing Well",
];

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [brand, setBrand] = useState("All Brands");
  const [website, setWebsite] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      const res = await axios.post(`${API}/newsletter/subscribe`, { email, brand, website });
      setMessage(res.data.message);
      setStatus("done");
      setEmail("");
    } catch (err) {
      setMessage(err?.response?.data?.detail || "Something went wrong. Please try again.");
      setStatus("error");
    }
  };

  if (status === "done") {
    return (
      <div className="flex items-center gap-2 text-small" data-testid="newsletter-success" style={{ color: "var(--gg-logo-gold)" }}>
        <CheckCircle2 size={16} /> {message}
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3" data-testid="newsletter-form">
      <div aria-hidden="true" style={{ position: "absolute", left: "-9999px", width: "1px", height: "1px", overflow: "hidden" }}>
        <label htmlFor="newsletter-website">Leave this field empty</label>
        <input id="newsletter-website" type="text" tabIndex={-1} autoComplete="off" value={website} onChange={(e) => setWebsite(e.target.value)} />
      </div>

      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        data-testid="newsletter-email-input"
        className="neu-inset flex-1 h-12 px-4 text-[16px] font-sans"
        style={{ color: "var(--gg-ivory)" }}
      />

      <Select value={brand} onValueChange={setBrand}>
        <SelectTrigger data-testid="newsletter-brand-select" className="neu-inset h-12 sm:w-[220px]" style={{ color: "var(--gg-ivory)" }}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent style={{ background: "var(--gg-deep-charcoal)", borderColor: "var(--gg-fine-border)", color: "var(--gg-ivory)" }}>
          {NEWSLETTER_BRANDS.map((b) => (
            <SelectItem key={b} value={b} data-testid={`newsletter-brand-option-${b.toLowerCase().replace(/\s+/g, "-")}`}>{b}</SelectItem>
          ))}
        </SelectContent>
      </Select>

      <button type="submit" disabled={status === "loading"} className="btn-solid-pearl whitespace-nowrap" data-testid="newsletter-submit-btn">
        {status === "loading" ? <Loader2 size={16} className="animate-spin mr-2" /> : null}
        Subscribe
      </button>

      {status === "error" && (
        <p className="text-small w-full" style={{ color: "#E39B9B" }} data-testid="newsletter-error">{message}</p>
      )}
    </form>
  );
};

export default NewsletterForm;
